function config($logProvider, $locationProvider, $httpProvider, matchmediaProvider, breakpoints, $compileProvider, environment) {
  'ngInject';

  // Enable log
  // $httpProvider.defaults.withCredentials = true;
  $httpProvider.defaults.withCredentials = true;
  // $httpProvider.interceptors.push(function ($q, $cookies) {
  //   return {
  //     'request': function (config) {
  //       // config.headers['auth-token'] = 'rW%2FddNofxDXuIFoqdK%2BZ3YzHmnFyU9kBgFCeo2hjtdY%3D';
  //       config.headers['auth-token'] = 'kLMH9yAwDRH3ClotYoXJ%2BDh2ftXq5sktcHcmAqZILu8%3D';
  //       // config.headers['auth-token'] = 'Amf2bfYlVMAffPOYVoyVEn0gC3yhjV27RoYDTpilRSs%3D';
  //       return config;
  //     }
  //   };
  // });
  $logProvider.debugEnabled(true);
  $locationProvider.html5Mode(true);

  matchmediaProvider.rules.phone = breakpoints.small;
  matchmediaProvider.rules.tablet = breakpoints.medium;
  matchmediaProvider.rules.desktop = breakpoints.largeStart;

  if(environment.name === 'Production') {
    $compileProvider.debugInfoEnabled(false);
  }

  ////Setup Global Raven config.
  //if (environment.name !== "Development") {
  //  Raven.config(environment.sentry.url).install();
  //}
}

export default config;



/** WEBPACK FOOTER **
 ** ./src/app/app.config.js
 **/